import { memo } from 'react';

const paths = {
  upload: 'M12 16V4m0 0l-4 4m4-4l4 4M4 20h16',
  download: 'M12 4v12m0 0l-4-4m4 4l4-4M4 20h16',
  rotateCW: 'M21 12a9 9 0 1 1-3-6.7M21 4v5h-5',
  rotateCCW: 'M3 12a9 9 0 1 0 3-6.7M3 4v5h5',
  trash: 'M4 7h16M9 7V4h6v3m-8 0l1 13h8l1-13',
  copy: 'M8 8h11v11H8zM5 5h11v3M5 5v11h3',
  plus: 'M12 5v14M5 12h14',
  close: 'M6 6l12 12M18 6L6 18',
  settings: 'M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z',
  doc: 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5zM14 3v5h5',
  code: 'M8 8l-5 4 5 4M16 8l5 4-5 4M14 4l-4 16',
  reset: 'M3 12a9 9 0 1 0 2.5-6.2M3 3v5h5',
  check: 'M5 12l5 5L20 7',
  warning: 'M12 9v4m0 4h.01M10.3 3.86L1.82 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.71 3.86a2 2 0 0 0-3.42 0z',
  merge: 'M6 3v8a4 4 0 0 0 4 4h8M18 21l3-3-3-3',
  selectAll: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
  hint: 'M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c.6.4 1 1 1 1.8V18h6v-1.5c0-.7.4-1.4 1-1.8A7 7 0 0 0 12 2z',
  select: 'M3 3l7 17 2-7 7-2L3 3z',
  text: 'M5 6V4h14v2M12 4v16M9 20h6',
  sign: 'M3 17l4-1 9-9-3-3-9 9-1 4zM14 5l3 3M5 21h14',
  rect: 'M4 5h16v14H4z',
  shape: 'M4 5h16v14H4z',
  hilite: 'M3 18h18M14 4l6 6-9 9-6 1 1-6 8-10z',
  pen: 'M12 19l7-7 3 3-7 7-3-3zM18 13l-1.5-1.5M2 22l3-1 4-9-2-2-9 4-1 3 5 5z',
  globe: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zM2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20',
  undo: 'M21 12a9 9 0 0 0-9-9c-4 0-7.2 2.6-8.5 6M3 3v6h6',
  redo: 'M3 12a9 9 0 0 1 9-9c4 0 7.2 2.6 8.5 6M21 3v6h-6',
  eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z',
  chevLeft: 'M15 18l-6-6 6-6',
  chevRight: 'M9 18l6-6-6-6',
  heart: 'M12 21s-7-4.35-9.5-9C1 8.5 3 4 7.5 4c2 0 3.5 1 4.5 2.5C13 5 14.5 4 16.5 4 21 4 23 8.5 21.5 12 19 16.65 12 21 12 21z',
  history: 'M3 12a9 9 0 1 0 3-6.7M3 4v5h5M12 7v5l3 2',
  underline: 'M6 4v8a6 6 0 0 0 12 0V4M5 20h14',
  strike: 'M4 12h16M7 8a5 4 0 0 1 10 0M7 16a5 4 0 0 0 10 0',
  circle: 'M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16z',
  ellipse: 'M12 7c5 0 9 2.2 9 5s-4 5-9 5-9-2.2-9-5 4-5 9-5z',
  square: 'M5 5h14v14H5z',
  squareFill: 'M5 5h14v14H5z',
  line: 'M4 20L20 4',
  front: 'M10 10h11v11H10zM4 4h9v3M4 4v9h3',
  back: 'M3 3h11v11H3zM14 14v7h7v-11h-7',
  scissors: 'M6 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM6 14a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM8.6 8.6L20 18M8.6 15.4L20 6',
  grip: 'M9 5h.01M9 12h.01M9 19h.01M15 5h.01M15 12h.01M15 19h.01',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1',
};

// Icons drawn as solid shapes instead of outlines.
const FILLED = new Set(['squareFill']);

function IconBase({ name, size = 18, stroke = 1.7, className = '', style }) {
  const d = paths[name];
  if (!d) return null;
  const filled = FILLED.has(name);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}

export const Icon = memo(IconBase);
